import { RemoveRedEyeOutlined } from "@mui/icons-material";
import {
	Avatar,
	AvatarGroup,
	Box,
	Button,
	Card,
	CardActions,
	CardContent,
	CardHeader,
	Checkbox,
	Grid,
	IconButton,
	Popover,
	Stack,
	Typography,
} from "@mui/material";
import { useState } from "react";
import { useGrapeList } from "./context/GrapeListProvider";

export const Group = ({ group }) => {
	const [anchorEl, setAnchorEl] = useState(null);
	const { toggleProduct, isSelected } = useGrapeList();

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const open = Boolean(anchorEl);

	return (
		<Grid item md={4}>
			<Card>
				<CardHeader
					subheader={`Group details\n Name: ${group.name}`}
					sx={{
						"& .MuiCardHeader-subheader": {
							whiteSpace: "pre-line",
						},
					}}
				/>
				<CardContent>
					<Typography variant="h6" component="div">
						Product:
					</Typography>

					<AvatarGroup
						componentsProps={{
							additionalAvatar: {
								onClick: (e) => {
									console.log("yes");
									handleClick(e);
								},
								sx: {
									cursor: "pointer",
									bgcolor: "primary.main",
								},
								title: "See all products", // optional tooltip
							},
						}}
						sx={{
							justifyContent: "center",
						}}
						total={group.products?.length}
					>
						{group.products?.slice(0, 4).map((product, i) => (
							<Avatar
								key={`group-pro-${i}`}
								alt={product.name}
								src={product?.image?.file}
							/>
						))}
					</AvatarGroup>
				</CardContent>

				<CardActions disableSpacing>
					{group.products?.length > 0 && (
						<IconButton
							onClick={handleClick}
							sx={{ marginLeft: "auto" }}
						>
							<RemoveRedEyeOutlined />
						</IconButton>
					)}
				</CardActions>
			</Card>
			<Popover
				id={`id-${group.id}`}
				open={open}
				anchorEl={anchorEl}
				onClose={handleClose}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "left",
				}}
			>
				<CardContent>
					<Typography paragraph>Products:</Typography>
					<Box>
						{group.products?.map((product, i) => {
							return (
								<Stack
									key={`playoff-group-${i}`}
									direction="row"
									alignItems="center"
									gap={1}
								>
									<Checkbox
										checked={isSelected(product.id)}
										onChange={() => {
											toggleProduct(product);
										}}
									/>
									<Avatar
										alt={product.name}
										src={product?.image?.file}
									/>
									<Typography
										paragraph
										sx={{
											marginBottom: 0,
										}}
									>
										{product.name}
									</Typography>
								</Stack>
							);
						})}
					</Box>
				</CardContent>
				<CardActions
					sx={{
						justifyContent: "flex-end",
						px: 2,
						pb: 2,
					}}
				>
					<Button variant="contained" onClick={handleClose}>
						Done
					</Button>
				</CardActions>
			</Popover>
		</Grid>
	);
};
